module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/5ac06e6f192e9f78b113cebc26f1fa9b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/past-ribbons/ribbon-silver.svg
// module id = Phym
// module chunks = 1